module.exports = __webpack_public_path__ + "img/Bengisu Berispek.2b732888.jpg";